import morphAttrs from './morphAttrs';
import morphdomFactory from './morphdom';

let morphdom = morphdomFactory(morphAttrs);

export default morphdom;
